import { useRef, useState } from 'react';
import '../../../App.css';
import Table from '../../Table';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';

import { handleErrors, request } from '../../../utils/ApiUtils';
import { showNotification } from '../../../utils/NotificationUtils';
import Input from '../../Input';
import Button from '@mui/material/Button';
import { FaCog } from 'react-icons/fa';

function ConfigDespesas() {
    const navigate = useNavigate();

    const [filter, setFilter] = useState('');
    const [pageData, setPageData] = useState({});
    const [dataArray, setDataArray] = useState([]);
    const [loading, setLoading] = useState({loading: false});
    const firstRender = useRef(0);
    const [fetchListError, setFetchListError] = useState();
    const [refreshKey, setRefreshKey] = useState(0);

    const triggerRefresh = () => setRefreshKey((prev) => prev + 1);

    const carregarDados = async (page = 0) => {
        setLoading({loading: true});

        request(`configdespesas/paginated?page=${page}&query=${filter || ''}`, {
            type: 'POST',
            body: JSON.stringify({}),
            callback: (data) => {
                setPageData(data);
                setDataArray(data.content);
            },
            callbackError: (responseData, message) => { handleErrors(responseData, 'Falha ao buscar configurações de despesas: '+message, {setFetchListError}) },
            finally: () => setLoading({loading: false})
        })
    };


    useEffect(() => { carregarDados(); }, []);

    useEffect(() => { 
        if (firstRender.current < 1) {
            firstRender.current = firstRender.current+1;
            return;
        }
        carregarDados(0); 
    }, [filter]);

    const salvar = async (configDespesa) => {
        const method = configDespesa.id ? "PUT" : "POST";
        const url = configDespesa.id ? `configdespesas/${configDespesa.id}` : "POST";

        request(url, {
            type: method,
            body: JSON.stringify(configDespesa),
            callback: (data) => {
                showNotification('Configuração alterada', 'success');
            },
            callbackError: (responseData, message) => {
                responseData?.error ?
                    showNotification(responseData.error, 'error') :
                    showNotification('Não foi possível alterar a configuração, revise o cadastro.', 'error');
            },
            finally: () => {
                triggerRefresh()
            }
        })
    };


    const tableParams = {
        query: (page) => carregarDados(page),
        triggerRefresh: triggerRefresh,
        columns: [
            {
                label: "Nome",
                width: "30%",
                type: "input",
                key: "nome",
                disable: true,
                getValue: (item) => item.nome
            },
            {
                label: "Categoria",
                width: "10%",
                type: "checkbox",
                disabled: true,
                key: "categoria",
                getValue: (item) => item.categoria,
                onClick: (item) => {
                    item.categoria = !item.categoria
                    salvar(item);
                }
            },
            {
                label: "Centro de custo",
                width: "10%",
                type: "checkbox",
                disabled: true,
                key: "ativo",
                getValue: (item) => item.centroCusto,
                onClick: (item) => {
                    item.centroCusto = !item.centroCusto
                    salvar(item);
                }
            },
            {
                label: "Ativo",
                width: "10%",
                type: "checkbox",
                disabled: true,
                key: "ativo",
                getValue: (item) => item.ativo,
                onClick: (item) => {
                    item.ativo = !item.ativo
                    salvar(item);
                }
            },
            {
                label: "Editar",
                width: "5%",
                type: "button-icon",
                css: "button",
                icon: (<VisibilityIcon />),
                onClick: (configDespesa) => navigate(`/configdespesas/cadastro/${configDespesa.id}`)
            }
        ]
    };

    return (
        <div className="form-container list-page">


            <div id="notification-container" className='notification-container' style={{
                position: "fixed",
                display: "flex",
                justifyContent: "flex-end",
                flexWrap: "wrap-reverse",
                alignItems: "flex-end",
                top: "0", // Aqui muda pra aparecer no topo
                right: "30px",
                maxHeight: "100vh",
                zIndex: 9999
            }}></div>

            <div className="header-container">
                <div className="page-title-content">
                    <FaCog aria-hidden="true" />
                    <h1 style={{ color: 'black' }}>Configuração de despesas</h1>
                </div>
                <Button className="new-contract-button" variant="contained" onClick={() => navigate(`/configdespesas/cadastro`)}>
                    Nova configuração
                </Button>
            </div>

            <div className='row'>

                <Input id="filtro"
                    parameters={{
                        width: '30%', label: "Filtre por nome", onChange: (value) => {
                            setFilter(value);
                        }
                    }} />
            </div>

            <Table params={tableParams} dataArray={dataArray} pageData={pageData} filter={filter} refreshKey={refreshKey} loading={loading} errorOccurred={fetchListError} />
        </div>
    );
}

export default ConfigDespesas;
